import { Component, OnInit, Input } from '@angular/core';
import { Banner } from '@models/product';

@Component({
  selector: 'gob-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {
  @Input() banner: Banner;
  _banners: Banner[];
  @Input()
  set banners(val: Banner[]){
    this._banners=val;
    if(val){
      this.banner=val.find(banner => {
        const startTime = new Date(banner.start).setHours(0, 0, 0, 0);
        const endTime = new Date(banner.end).setHours(0, 0, 0, 0);
        /* let start = new Date(banner.start).setHours(0, 0, 0, 0);
        let end = new Date(banner.end).setHours(0, 0, 0, 0); */
        const todayMidnight = new Date();
        todayMidnight.setHours(0, 0, 0, 0);
        const todayTime = todayMidnight.getTime();
        if(banner.start == null && banner.end == null)
          return true;
        if(banner.start != null && banner.end == null && startTime <= todayTime)
          return true;
        /* if(start <= now.getTime() && end >= now.getTime()) */
        if(startTime <= todayTime && endTime >= todayTime)
          return true;
        return false;
      });
    }
  }

  get banners(){
    return this._banners;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
